<template>
  <v-text-field
    v-bind="$attrs"
    :label="label"
    :required="required"
    :autofocus="autofocus"
    :type="inputType"
    :value="value"
    @input="$emit('input', $event)"
  >
    <template #append>
      <PhEye
        v-if="showPassword"
        :size="20"
        @click="showPassword = false"
        class="cursor-pointer"
      />
      <PhEyeSlash
        v-else
        :size="20"
        @click="showPassword = true"
        class="cursor-pointer"
      />
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'PasswordField',

  inheritAttrs: false,

  props: {
    value: { type: String, default: '' },
    label: { type: String, required: true },
    required: { type: Boolean, default: false },
    autofocus: { type: Boolean, default: false }
  },

  data() {
    return {
      showPassword: false
    };
  },

  computed: {
    inputType() {
      return this.showPassword ? 'text' : 'password';
    }
  }
};
</script>
